import React from 'react';
import { useTheme } from '@mui/material/styles';
import PanelAlert from '../../../shared/components/PanelAlert';

/**
 * Pattern Panel Alert Component
 * Shows selection info for pattern extraction
 */
const PatternPanelAlert = ({ selectedRows, selectedUploadRows, ...props }) => {
  const theme = useTheme();
  const totalSelected = selectedRows.length + selectedUploadRows.length;

  const getPrimaryMessage = () => {
    if (totalSelected === 0) {
      return 'Select structures to apply pattern extraction';
    }
    
    let message = `${totalSelected} structure${totalSelected !== 1 ? 's' : ''} selected`;
    if (selectedRows.length > 0 && selectedUploadRows.length > 0) {
      message += ` (${selectedRows.length} existing, ${selectedUploadRows.length} pending upload)`;
    }
    return message;
  };

  const getSecondaryMessage = () => {
    if (totalSelected === 0) {
      return 'Pattern will extract metadata from file paths';
    }
    return 'Pattern extraction will be applied to all selected structures';
  };

  return (
    <PanelAlert
      severity={totalSelected > 0 ? "info" : "warning"}
      primaryMessage={getPrimaryMessage()}
      secondaryMessage={getSecondaryMessage()}
      sx={{
        mx: theme.spacing(2),
        mt: theme.spacing(2),
        mb: theme.spacing(1.5)
      }}
      {...props}
    />
  );
};

export default PatternPanelAlert;